import React from 'react';
import {IconButton, makeStyles, Menu, MenuItem, Typography} from "@material-ui/core";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import axios from "axios";
import * as spotifyController from "../../../controllers/spotifyController";
import {getState} from "../../../controllers/stateController";

const useStyles = makeStyles((theme) => ({
    iconButton: {
        color: "white",
    },
    list: {
        backgroundColor: theme.palette.secondary.light
    },
    count: {
        marginRight: theme.spacing(2)
    }
}))

function SongActionButton( {song, handleVote, hasVotedAlready, handleRemove, canVote=true} ) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleSelect = (label) => {
        if(label === "vote") {
            handleVote(song)
        }
        else if(label === "play") {
            spotifyController.playNextSong(song.albumUri, song.albumOffset, false)
            handleRemove(song)
        }
        else if(label === "remove") {
            handleRemove(song)
        }
        else if(label === "ban") {
            axios.post(global.API_URL + "/ban-song", {
                artists: song.artists,
                songId: song.spotify_id,
                title: song.title,
                token: getState().apiToken,
            }).catch(function (error) {
                    console.log(error)
            })
            handleRemove(song)
        }

        handleClose()
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
                color="primary"
                classes={{
                    colorPrimary: classes.iconButton
                }}
            >
                {canVote
                ? <Typography variant="h6" color="initial" className={classes.count}>
                        <b>{song.votes}</b>
                    </Typography>
                : null
                }

                <MoreVertIcon />
            </IconButton>
            <Menu
                id="song-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                classes={{
                    paper: classes.list
                }}
            >
                {canVote
                    ? <MenuItem button disabled={!hasVotedAlready(song)} aria-label="vote" id="vote" onClick={() => handleSelect("vote")}>Vote for Song</MenuItem>
                    : null
                }
                <MenuItem button aria-label="play" id="play" onClick={() => handleSelect("play")}>Play Song Now</MenuItem>
                <MenuItem button aria-label="remove" id="remove" onClick={() => handleSelect("remove")}>Remove Song</MenuItem>
                <MenuItem button aria-label="ban" id="ban" onClick={() => handleSelect("ban")}>Ban Song</MenuItem>

            </Menu>
        </div>
    )
}

export default SongActionButton
